import { db } from "@/main";

import { DB } from "@/common/store";

export const CHECKIN = "Checkin";
export const CHECKOUT = "Checkout";
export const FECALYSIS = "Fecalysis";
export const PHOTO = "Photo";
export const TEMPERATURE = "Temperature";
export const URINALYSIS = "Urinalysis";
export const XRAY = "Xray";

export const FILTER_ALL = "All Submissions";
export const FILTER_COMPLETE = "Complete Submissions";
export const FILTER_INCOMPLETE = "Incomplete Submissions";

function GetValue(key) {
  return window.localStorage.getItem(key);
}

function SetValueOrRemove(key, value) {
  if (value) {
    window.localStorage.setItem(key, value);
  } else {
    window.localStorage.removeItem(key);
  }
}

const MEDISURE_ACTIVE_OFFSITE_ID = "medisureActiveOffsiteId";
const MEDISURE_ACTIVE_OFFSITE_NAME = "medisureActiveOffsiteName";
const MEDISURE_ACTIVE_OFFSITE_SCHEDULE = "medisureActiveOffsiteSchedule";

export function GetActiveOffsiteService() {
  return {
    id: GetValue(MEDISURE_ACTIVE_OFFSITE_ID),
    name: GetValue(MEDISURE_ACTIVE_OFFSITE_NAME),
    schedule: GetValue(MEDISURE_ACTIVE_OFFSITE_SCHEDULE)
  };
}

export function SetActiveOffsiteService(details) {
  SetValueOrRemove(MEDISURE_ACTIVE_OFFSITE_ID, details ? details.id : null);

  SetValueOrRemove(
    MEDISURE_ACTIVE_OFFSITE_NAME,
    details ? details.serviceName : null
  );

  SetValueOrRemove(
    MEDISURE_ACTIVE_OFFSITE_SCHEDULE,
    details ? details.schedule : null
  );
}

function createSubmissionEntry() {
  return {
    name: "",
    [XRAY]: false,
    [FECALYSIS]: false,
    [URINALYSIS]: false
  };
}

function MapSubmissions(scheduleId) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .where("scheduleId", "==", scheduleId)
      .get()
      .then(snapshot => {
        let submissionMap = {};

        snapshot.forEach(doc => {
          const data = doc.data();

          if (!(data.userCode in submissionMap)) {
            submissionMap[data.userCode] = createSubmissionEntry();
          }

          submissionMap[data.userCode][data.type] = true;
        });

        resolve(submissionMap);
      })
      .catch(err => reject(err));
  });
}

function MapUsers(scheduleId) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_ATTENDEE)
      .where("service.id", "==", scheduleId)
      .get()
      .then(snapshot => {
        let userMap = {};

        snapshot.forEach(doc => {
          const user = doc.data().user;
          userMap[user.code] = `${user.firstName} ${user.lastName}`;
        });

        resolve(userMap);
      })
      .catch(err => reject(err));
  });
}

export function ConsolidateMapSubmission(scheduleId) {
  return new Promise((resolve, reject) => {
    let submissions = {};

    MapSubmissions(scheduleId)
      .then(submissionMap => {
        submissions = { ...submissionMap };
        return MapUsers(scheduleId);
      })
      .then(userMap => {
        for (const userCode in userMap) {
          if (!(userCode in submissions)) {
            submissions[userCode] = createSubmissionEntry();
          }
          submissions[userCode]["name"] = userMap[userCode];
        }
        resolve(submissions);
      })
      .catch(err => reject(err));
  });
}

export function GetLastSubmission(
  scheduleId,
  userCode,
  submissionType,
  lastFunction
) {
  return new Promise((resolve, reject) => {
    db.collection(DB.OFFSITE_SUBMISSIONS)
      .where("scheduleId", "==", scheduleId)
      .where("userCode", "==", userCode)
      .where("type", "==", submissionType)
      .get()
      .then(snapshot => resolve(lastFunction(snapshot)))
      .catch(err => reject(err));
  });
}
